export default __webpack_public_path__ + "static/media/double-caret-right.20700f78.svg";